import { FC } from "react";
import GetTheApp from "@/components/GetTheApp/GetTheApp";

import styles from "./AdvantageCardParentCTA.module.scss";

const AdvantageCardParentCTA: FC = () => {
  return (
    <div className={styles.OuterContainer}>
      <GetTheApp />
    </div>
  );
};

export default AdvantageCardParentCTA;
